enum AssetType {
    AUTOMOBILE = 'automobile',
    POWERSPORTS_VEHICLE = 'powersports_vehicle',
    RECREATIONAL_VEHICLE = 'recreational_vehicle',
    MARINE = 'marine',
}

export default AssetType
